export const columns = [
  { accessorKey: "firstName", header: "First Name", flex: 1 },
  { accessorKey: "lastName", header: "Last Name", flex: 1 },
  { accessorKey: "username", header: "User Name", flex: 1 },
  {
    accessorKey: "email",
    header: "Email",
    description: "This column has a value getter and is not sortable.",
    sortable: true,
    flex: 1,
  },
  { accessorKey: "location", header: "Location", flex: 1 },
  { accessorKey: "terminalName", header: "Terminal Name", flex: 1 },
  { accessorKey: "appointment", header: "Appointment", flex: 1 },
  {
    accessorKey: "isActive",
    header: "Active",
    flex: 1,
    type: "boolean",
  },
  {
    accessorKey: "isAllowToExportData",
    header: "Export Data",
    flex: 1,
    type: "boolean",
  },
  {
    accessorKey: "phoneNumber",
    header: "Phone Number",
    size: 200,
    type: "string",
  },
];
